import { Drawer } from '@mui/material';
import { observer } from 'mobx-react-lite';
import styles from './index.module.scss';
import { useClinicalEventsModal } from './Provider';
import DrawerContent from './DrawerContent';
import useQueryParam from '../../../../hooks/useCustomQueryParam';

const ClinicalEventModal = ({
  onChange,
}: {
  onChange: (uuid: string) => void;
}) => {
  const [newEvent] = useQueryParam<string | undefined>('newEventUuid');

  const {
    contextData: { clinicalEventUuid, isNewItem },
  } = useClinicalEventsModal();

  return (
    <Drawer
      className={styles.eventModal}
      classes={{ paper: styles.paper }}
      anchor={'right'}
      open={!!clinicalEventUuid || !!isNewItem || !!newEvent}>
      <DrawerContent onChange={onChange} />
    </Drawer>
  );
};

export default observer(ClinicalEventModal);
